// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorPageLayout_container__3g_qj","logo":"ErrorPageLayout_logo__aGJWA","main":"ErrorPageLayout_main__3WUaO"};